module.exports = __webpack_public_path__ + "img/9788997853083.fd52dc2b.jpg";